import { createStart, createMiddleware } from "@tanstack/react-start";
import { attachCurrentAuth } from "@/lib/auth-function-middleware";
import { renderErrorPage } from "@/lib/error-page";

// Logs the original Error (with stack) before h3 turns it into an opaque 500.
const errorMiddleware = createMiddleware().server(async ({ next, request }) => {
  try {
    return await next();
  } catch (error) {
    if (error instanceof Response) throw error;
    if (error && typeof error === "object" && "statusCode" in error) throw error;
    const path = new URL(request.url).pathname;
    console.error("[SSR FATAL · request-middleware]", { path });
    console.error(error);
    return new Response(renderErrorPage({ path }), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8", "cache-control": "no-store" },
    });
  }
});

export const startInstance = createStart(() => ({
  requestMiddleware: [errorMiddleware],
  // AuthContext restores the session once. Re-reading it for every public RPC
  // queues those requests behind the same preview-storage/session lock.
  // Protected server functions retain their own authorization middleware.
  functionMiddleware: [attachCurrentAuth],
}));
